import { get, post } from "./api";

export const fetchCurrentProfile = () => {
  return get("/api/v2/current_profile/");
};

export const fetchProfiles = (params = {}) => {
  return get("/api/v2/profiles/", params);
};

export const fetchProfile = (id, params = {}) => {
  return get(`/api/v2/profiles/${id}/`, params);
};

export const signup = (data) => {
    return post("/api/v2/signup/", data);
};

export const linkCustomerToProfile = (profileId, customerId) => {
  return post(`/api/v2/profiles/${profileId}/link_customer/`, { customer_id: customerId });
};

export const unlinkCustomerFromProfile = (profileId, customerId) => {
  return post(`/api/v2/profiles/${profileId}/unlink_customer/`, { customer_id: customerId });
};

export const bulkLinkCustomers = (profileId, customersToLink, customersToUnlink, accountRoles = {}) => {
  return post(`/api/v2/profiles/${profileId}/bulk_link_customers/`, { 
    customer_ids: customersToLink,
    unlink_customer_ids: customersToUnlink,
    account_roles: accountRoles
  });
};

export const exportProfiles = (profileIds = null) => {
  const data = profileIds ? { profile_ids: profileIds } : {};
  return post("/api/v2/export_profiles/", data);
};